<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="租户编号" prop="code" style="width: 80%">
                <el-input
                  v-model="searchForm.code"
                  placeholder="请输入租户编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租户名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入租户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="联系人名称"
                prop="link"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.link"
                  placeholder="请输入联系人名称/编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addUser"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          @click="onLoad"
          type="primary"
          icon="el-icon-search"
          style="width: 90px"
          >搜索</el-button
        >
        <el-button
          size="small"
          @click="restSearch"
          type="danger"
          style="width: 90px"
          >重置</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="code" label="租户编号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="租户名称" align="center">
        </el-table-column>
        <el-table-column prop="linkName" label="联系人名称" align="center">
        </el-table-column>
        <el-table-column prop="linkPhone" label="联系人电话" align="center">
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope.row)"
              >修改</el-button
            >
            <el-button @click="resetPsw(scope.row)" type="text" size="small"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="modalTitle"
        :visible.sync="isAddModal"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="联系人名称"
                label-width="100px"
                prop="linkName"
              >
                <el-input
                  v-model="addData.linkName"
                  placeholder="请输入联系人名称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="联系人电话"
                label-width="100px"
                prop="linkPhone"
              >
                <el-input
                  v-model="addData.linkPhone"
                  placeholder="请输入联系人电话"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="租户名称" label-width="100px" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入租户名称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" label-width="100px" prop="remark">
                <el-input
                  v-model="addData.remark"
                  placeholder="请输入备注"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
        code: "",
        link: "",
        name: "",
      },
      modalTitle: "新增",
      isShowLabel: true, //修改的时候为false  无法修改账号密码
      roleList: [], //角色信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id:'',
        remark: "", //备注
        name: "", //租户名称
        linkPhone: "", //联系人电话
        linkName: "", //联系人名称
        code: "", //	租户编号
        status: "1", //状态 1正常 -1 冻结
      },
      addDataRules: {
        linkName: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
        ],
        linkPhone: [
          { required: true, message: "请输入您的电话", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.mobile(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  mounted() {
    this.onLoad();
    this.$Apis.getCharacterList().then((res) => {
      if (res.code == 200) {
        let { list } = res.data;
        this.roleList = list;
      }
    });
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 重置密码
    resetPsw(row) {
      this.$confirm("您确定要重置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.tenantReset({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$alert(res.data, "账号密码", {
              confirmButtonText: "确定",
              center: true,
              callback: (action) => {
                this.onLoad();
              },
            });
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    //   删除用户
    del(row) {
      this.$confirm("您确定要删除该用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.delUser({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 修改用户状态
    updateLockStates(row) {
      this.$Apis
        .updateLockStates({
          id: row.id,
          lockStatus: row.lockStatus == true ? "2" : "1",
        })
        .then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    // 修改用户状态
    updataStatus(row) {
      this.$Apis
        .tenantStatus({
          id: row.id,
          status: row.status == true ? 1 : -1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    userStatus(row) {
      if (row.status == "1") {
        return "正常";
      } else {
        return "冻结";
      }
    },
    lockStatus(row) {
      if (row.lockStatus == "1") {
        return "正常";
      } else {
        return "已上锁";
      }
    },
    onlineStatus(row) {
      if (row.onlineStatus == "1") {
        return "在线";
      } else {
        return "离线";
      }
    },
    // 新增用户
    addUser() {
      this.modalTitle = "新增";
      this.isAddModal = true;
      this.addData.id = ''
      this.addData.linkName = "";
      this.addData.linkPhone = "";
      this.addData.name = "";
      this.addData.remark = "";
    },
    updata(row) {
      this.modalTitle = "修改";
      this.isAddModal = true;
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.status = this.addData.status == true ? 1 : -1;
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let data = this.addData;
          this.$Apis.tenantUpdata(data).then((res) => {
            this.btnLoading = false;
            if (res.code == 200) {
              this.isAddModal = false;
              if (this.modalTitle == "新增") {
                this.$alert(res.data, "账号密码", {
                  confirmButtonText: "确定",
                  center:true,
                  callback: (action) => {
                    this.onLoad();
                  },
                });
              } else {
                this.onLoad();
              }
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
        this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.$Apis.tenantList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            item.status = item.status == 1 ? true : false;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
</style>